import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Tooltip, makeStyles } from '@material-ui/core'
import BasicTable from '../../../../../atoms/BasicTable'
import { useFormattingContext } from '../../../../../organisms/FormattingProvider/FormattingContext'
import Markup from '../../../../../atoms/Markup'
import Icon from '../../../../../atoms/Icon'

const useStyles = makeStyles(() => ({
  descriptionWrap: {
    '&.MuiTooltip-popper': {
      '& .MuiTooltip-tooltipPlacementTop': {
        minWidth: '30vw',
        backgroundColor: 'var(--theme-color-surface-d0)',
        color: 'var(--text-color-main)',
        border: 'var(--border-neutral-emphasis)',
        boxShadow: 'var(--shadow-sm)',
        fontSize: 'var(--font-size-sm)',
        padding: 'var(--padding-sm) var(--padding-md)'
      },
      '& .MuiTooltip-tooltipPlacementBottom': {
        minWidth: '30vw',
        backgroundColor: 'var(--theme-color-surface-d0)',
        color: 'var(--text-color-main)',
        border: 'var(--border-neutral-emphasis)',
        boxShadow: 'var(--shadow-sm)',
        fontSize: 'var(--font-size-sm)',
        padding: 'var(--padding-sm) var(--padding-md)'
      }
    }
  }
}))

function ApiInputsTable ({ apiInputs }) {
  const classes = useStyles()
  const { formatter } = useFormattingContext()
  const tooltipTitle = useCallback((description) => {
    return (
      <Markup type='markdown' value={description} />
    )
  }, [])

  if (!apiInputs || apiInputs.length === 0) {
    return (
      <div style={{ padding: 'var(--padding-md)', color: 'var(--text-color-subtle)' }}>
        No API inputs defined
      </div>
    )
  }

  return (
    <BasicTable className='opal-presentation-table zebra-rows primary'>
      <thead className='opt-thead'>
        <tr className='opt-tr'>
          <th className='opt-th'>Input Name</th>
          <th className='opt-th'>Display Name</th>
          <th className='opt-th'>Data Type</th>
          <th className='opt-th'>Required</th>
          <th className='opt-th'>Default</th>
          <th className='opt-th'>Ordinal</th>
        </tr>
      </thead>
      <tbody className='opt-tbody'>
        {apiInputs.map((input) => (
          <tr className='opt-tr' key={`input_${input.catalogApiInputId || input.inputName}`}>
            <td className='opt-td'>
              {input.description ? (
                <Tooltip
                  title={tooltipTitle(input.description)}
                  classes={{
                    tooltip: 'big_tooltip',
                    popper: classes.descriptionWrap
                  }}
                >
                  <div className='flex flex-row gap-sm items-center'>
                    <span>{input.inputName}</span>
                    <Icon name='info' customSize={16} />
                  </div>
                </Tooltip>
              ) : (
                <span>{input.inputName}</span>
              )}
            </td>
            <td className='opt-td'>{input.displayName}</td>
            <td className='opt-td'>{input.dataType}</td>
            <td className='opt-td'>{formatter(!!input.isRequired, 'bool')}</td>
            <td className='opt-td'>
              {input.defaultValue ? (
                <span style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-size-sm)' }}>
                  {JSON.stringify(input.defaultValue)}
                </span>
              ) : (
                <span style={{ color: 'var(--text-color-subtle)' }}>—</span>
              )}
            </td>
            <td className='opt-td'>{input.ordinal}</td>
          </tr>
        ))}
      </tbody>
    </BasicTable>
  )
}

ApiInputsTable.propTypes = {
  apiInputs: PropTypes.arrayOf(PropTypes.shape({
    catalogApiInputId: PropTypes.number,
    inputName: PropTypes.string,
    displayName: PropTypes.string,
    dataType: PropTypes.string,
    isRequired: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    defaultValue: PropTypes.any,
    ordinal: PropTypes.number,
    description: PropTypes.string
  }))
}

export default ApiInputsTable
